import { ArcadePage, type ArcadeSpec } from "./ArcadeShell";
import { tk } from "../../../../lib/i18n";

const SPEC: ArcadeSpec = {
  id: "lastik", title: tk("Lastik Kuiz"), tone: "from-orange-500 to-rose-600", emoji: "🎯", w: 360, h: 520, mascot: true,
  intro: tk("Bantu Harraz atau Hannah melastik! Tarik ke belakang, bidik dan lepaskan untuk pecahkan kotak dengan jawapan betul."),
  hint: tk("Tarik ke belakang, bidik, kemudian lepaskan."),
  load: async () => (await import("./engines/lastik3d")).createLastik3d,
};
export const LastikKuizPage = () => <ArcadePage spec={SPEC} />;
